export default "/images/381d63e993319d1f1b8890f7c0f85010.avif";